import classNames from 'classnames';
import { ActionButton, Icon } from 'components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class Overlay extends Component {
  static propTypes = {
    hidden: PropTypes.bool,
    editable: PropTypes.bool,
    removable: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func
  };

  render() {
    const { hidden, editable, removable, onEdit, onDelete, isDraggable, isDragging, dragListeners } = this.props;

    if (hidden) {
      return null;
    }

    return (
      <div
        className={classNames('form-constructor-field__overlay', {
          'form-constructor-field__overlay--active': isDragging
        })}
      >
        {isDraggable && (
          <div className="form-constructor-field__overlay__drag-handle" {...dragListeners}>
            <Icon name="reorder" size="24" />
          </div>
        )}
        {editable && <ActionButton data-cy="edit" iconName="edit" onClick={onEdit} />}

        {removable !== false && <ActionButton data-cy="delete" iconName="delete" onClick={onDelete} />}
      </div>
    );
  }
}

export default Overlay;
